import { formatModelCodeForDisplay } from './modelCategoryRanges';

function normalizeStatus(status) {
  return String(status ?? '').trim().toLowerCase();
}

function normalizeBalance(balance) {
  const value = Number(balance);
  return Number.isFinite(value) ? value : 0;
}

export function getPaymentSublabel(order) {
  const status = normalizeStatus(order?.status);
  if (status === 'cancelled') return '—';
  return normalizeBalance(order?.balance) > 0 ? 'Due' : 'Paid';
}

export function getWholesaleQtyParts(items = []) {
  const list = Array.isArray(items) ? items : [];
  const totalQty = list.reduce((sum, item) => sum + (Number(item?.qty) || 0), 0);
  if (totalQty <= 0) return null;
  return {
    count: totalQty,
    label: totalQty === 1 ? 'murti' : 'murtis',
  };
}

export function getOrderQtyLine(order, items = []) {
  const type = String(order?.type ?? '').trim().toLowerCase();
  const list = Array.isArray(items) ? items : [];

  if (type === 'wholesale') {
    const parts = getWholesaleQtyParts(list);
    if (!parts) return '—';
    return `${parts.count} ${parts.label}`;
  }

  if (list.length === 0) return '—';
  const first = list[0];
  const modelName = String(first?.modelName || first?.model?.modelName || '').trim();
  const modelNumber = first?.modelNumber ?? first?.model?.modelNumber ?? '';
  const size = first?.model?.size || first?.size || '';
  const code = modelNumber
    ? formatModelCodeForDisplay(modelNumber, size || undefined)
    : '';

  let line = '';
  if (modelName && code) line = `${modelName} · ${code}`;
  else if (modelName) line = modelName;
  else if (code) line = code;
  else return '1 pc';

  return line;
}
